module.exports = __webpack_public_path__ + "files/b8832eb4c7dc00ea1cbb48cc48ae89a3.png";